<template>
  <div class="after_sale_info_warp">
    <div class="box-list-view" v-for="(item,index) in orderInfo" :key="index">
  <el-card class="box-card">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">收货信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="联系姓名">{{
              item.custName
            }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">{{
              item.custMobile
            }}</el-descriptions-item>
          <el-descriptions-item label="联系地址">
            {{ item.province }}
            {{ item.city }}
            {{ item.district }}
            <span >{{
                item.addressDetail
              }}</span>
            <!-- {{ item.address }} -->
          </el-descriptions-item>
          <el-descriptions-item label="平台订单号">{{
              item.unionNo
            }}</el-descriptions-item>
            <el-descriptions-item label="商户平台订单号">{{
              item.platformOrderNo
            }}</el-descriptions-item>
            <el-descriptions-item label="订单商品总数">{{
              item.totalNum
            }}</el-descriptions-item>
            <el-descriptions-item label="订单商品总金额">{{
              item.totalAmount
            }}</el-descriptions-item>
            <el-descriptions-item label="订单总运费">{{
              item.totalFreightAmount
            }}</el-descriptions-item>
            <el-descriptions-item label="支付总金额">{{
              item.payAmount
            }}</el-descriptions-item>
            <el-descriptions-item label="支付流水号">{{
              item.payNo
            }}</el-descriptions-item>
            <el-descriptions-item label="下单时间">{{
              formatApiDate(item.createTime)
            }}</el-descriptions-item>
            <el-descriptions-item label="支付时间">{{
              formatApiDate(item.payTime)
            }}</el-descriptions-item>
            <el-descriptions-item label="备注">{{
              item.remark
            }}</el-descriptions-item>
        </el-descriptions>
      </div>
    </el-card>
    
    <el-card class="box-card" style="width:100%" v-for="(nItem,nIndex) in item.orderList" :key="nIndex">
      <div class="card_title">
        <div class="card_title_fg"></div>
        <div class="card_title_msg">订单信息</div>
      </div>
      <div class="card_content">
        <el-descriptions>
          <el-descriptions-item label="子订单ID">{{
              nItem.suborderId
            }}</el-descriptions-item>
          <el-descriptions-item label="子单商品总金额">{{
              nItem.totalGoodsAmount
            }}</el-descriptions-item>
          <el-descriptions-item label="子单运费">{{
              nItem.freightAmount
            }}</el-descriptions-item>
            <el-descriptions-item label="子单总金额">{{
              nItem.totalAmount
            }}</el-descriptions-item>
            <el-descriptions-item label="订单状态">{{
              state[nItem.state + '']
            }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <div class="card_order_one">
        <div class="card_title">
          <div class="card_title_fg"></div>
          <div class="card_title_msg">商品信息</div>
        </div>
        <div class="card_content">
          <el-table :data="nItem.orderDetailList" style="width: 100%" size="mini">
            <el-table-column
                prop="orderDetailId"
                label="商品ID"
                width="120"
            ></el-table-column>
            <el-table-column
                prop="specCode"
                label="商品编号"
                width="120"
            ></el-table-column>
            <el-table-column prop="specName" label="商品名称"> </el-table-column>
            <el-table-column prop="num" label="商品规格">
              <template slot-scope="scope">
                <span>{{JSON.parse(scope.row.specInfo)['规格']}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="num" label="商品数量" width="80">
            </el-table-column>
            <el-table-column prop="unitPrice" label="商品单价" width="80">
            </el-table-column>
            <el-table-column prop="totalAmount" label="商品总金额" width="80">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="card_order_one">
        <div class="card_title">
          <div class="card_title_fg"></div>
          <div class="card_title_msg">物流信息</div>
        </div>
        <div class="card_content">
          <el-table :data="nItem.orderDeliveredList" style="width: 100%" size="mini">
            <el-table-column
                prop="expCode"
                label="物流编码"
            ></el-table-column>
            <el-table-column
                prop="expName"
                label="物流名称"
            ></el-table-column>
            <el-table-column
                prop="expNo"
                label="物流单号"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
   
    </div>
    
    <div class="dialog-footer">
      <el-button type="primary" @click="returnList">返回</el-button>
    </div>
  </div>
</template>

<script>
import { getOrderDetail,getSupplyOrderInfo } from "@/api/order";
import { formatApiDate } from "@/utils/utils";
import {AFTER_SALE_STATUS, getValue, ORDER_POSTAGES_TYPE, ORDER_STATUS} from "@/utils/enumUtile";

export default {
  name: "orderInfo",
  computed: {
    formatApiDate() {
      return formatApiDate;
    },
    ORDER_POSTAGES_TYPE() {
      return ORDER_POSTAGES_TYPE;
    },
    ORDER_STATUS() {
      return ORDER_STATUS;
    },
    AFTER_SALE_STATUS() {
      return AFTER_SALE_STATUS;
    }
  },
  data() {
    return {
      id: 0,
      orderInfo: [],
      listLoading: false,
      state:{'-2':'已退款','1':'已支付','2':'已发货','3':'已完成'}
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    const id = this.$route.params.id;
    if (id && id !== 0) {
      this.id = id;
      this.getList();
    }
  },
  watch: {},
  methods: {
    getValue,
    onExpressNo(){
      window.open('https://www.baidu.com/s?rsv_idx=1&wd=%E6%9F%A5%E5%BF%AB%E9%80%92%E5%8D%95%E5%8F%B7%E6%9F%A5%E8%AF%A2%E5%85%A5%E5%8F%A3','_blank')
    },
    getList() {
      const id = this.id;
      if (!id) {
        return;
      }
      this.listLoading = true;
      const params = {
        unionNo:id
      };
      getSupplyOrderInfo(params)
        .then(response => {
          this.orderInfo = response.result || [];
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    returnList() {
      this.$router.push({ path: "/order/list" });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/index";

.aa{
  display: inline-block;
}
.card_order_one{
  width:100%;
  margin-top:10px;
}
.box-list-view{
  width:100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  margin-bottom:20px;
  padding: 20px 10px 0 ;
  box-sizing: border-box;
}
.after_sale_info_warp {
  background-color: #eeeeee;
  padding: 20px;
  height: calc(100vh - 124px);
  overflow-y: auto;
  .box-card {
    margin-bottom: 20px;
  }
  .card_title {
    display: flex;
    align-items: center;
    .card_title_fg {
      height: 22px;
      width: 4px;
      background-color: $Theme-color;
    }
    .card_title_msg {
      margin-left: 6px;
    }
  }
  .card_content {
    margin-top: 10px;
    .descriptions_mar_warp {
      margin-top: 20px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: end;
  }
}
</style>
